<template>
  <v-card title="角色维护">
    <div class="grid-demo">
      <v-form slot="form">
        <v-row :gutter="24">
          <v-col class="gutter-row" span="8">
            <div style="text-align: left">
              <v-form-item>
                <v-button type="success" icon="plus" @click="add('')"
                  ><span>添加</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
          <v-col class="gutter-row" span="16">
            <div style="text-align: right">
              <v-form-item>
                <v-input
                  placeholder="输入角色名称"
                  v-model="cx"
                ></v-input>
              </v-form-item>
              <v-form-item>
                <v-button type="primary" icon="search" @click="findList()"
                  ><span>检索</span></v-button
                >
              </v-form-item>
            </div>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
    >
      <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="add(row)" title="修改">
              <v-icon type="edit"></v-icon>
            </a>
            &nbsp;&nbsp;
            <v-popconfirm
              title="确定删除角色吗?"
              @confirm="del(row)"
              @cancel="cancel"
              placement="bottom"
            >
              <a class="link" title="删除">
                <v-icon type="delete"></v-icon>
              </a>
            </v-popconfirm>
            </a>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
  </v-card>
</template>
<script>
let options = { rolename: "", description: "" };
let xf_options = [];
let cx = ""
export default {
  data() {
    return {
      xf_options,
      options,
      cx,
      tableData: [],
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: 408,
        headerAlign: "center",
        columns: [
          {
            type: "seq",
            title: "序号",
            width: 70,
            align: "center"
          },

          {
            field: "js_mc",
            title: "角色名称"
          },
          {
            field: "js_ms",
            title: "描述"
          },
          {
            field: "cz",
            title: "操作",
            align: "center",
            slots: {
              // 对应自定义插槽的名称
              default: "cz"
            }
          }
        ]
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {

      console.log(sessionStorage.getItem("token"))

      this.$axios
        .get(
          "api/system/qxgl/get-js-list?cx=" + this.cx
        )
        .then(res => {
          this.tableData = res.data.data;
        });
    },
    add: function (row) {
      let id = row == "" ? "" : row.id;
      let title = row == "" ? "添加角色" : "修改角色";
      xadmin.open(title, "/jswhadd?id=" + id, "900", "350");
    },
    del(row) {
      //this.selectRow = row;
      this.$axios.delete("api/system/qxgl/delete-js-first/" + row.id).then(res => {
        if (res.data.code == 200) {
          this.$message.info("删除成功");
          this.findList();
        } else {
          this.$message.info("删除失败");
        }
      });
    },
    cancel: function () {
      this.$message.info("取消删除");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/view/xtgl/qxgl/jswh.vue